import createTranslationsService from './translationsService';

// Function to create API services with a specific language
export const createApiService = (language) => {
  return {
    translations: createTranslationsService(language),
  };
};

// Get the current language from localStorage or use 'en' as default
const getCurrentLanguage = () => {
  if (typeof window !== 'undefined') {
    return localStorage.getItem('language') || 'en';
  }
  return 'en';
};

// Custom hook to get API services with the current language
export const useApiService = () => {
  // Get the current language directly from localStorage instead of context
  const language = getCurrentLanguage();
  return createApiService(language);
};

// Default export with language from localStorage (for backwards compatibility)
export default createApiService(getCurrentLanguage()); 